import Cookies from 'js-cookie';
import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { selectParentIsAuthenticated } from '../selectors';

interface PreDashboardRedirectProps {
  children: ReactElement | null;
}

// Parents who arrived through the lookup-by-student-id entry point carry an
// `active_redirect` cookie; once they are logged in the dashboard hands them
// straight on to that lookup. LookupByVenueAndStudentId clears the cookie on
// arrival, so returning to /dashboard afterwards does not bounce again.
//
// This used to call history.push() from inside App's render body. Redirecting
// declaratively keeps the navigation out of the render phase, where a side
// effect can fire more than once per committed render.
const PreDashboardRedirect: FC<PreDashboardRedirectProps> = ({ children }) => {
  const isAuthenticated = useSelector(selectParentIsAuthenticated);
  const activeRedirect = Cookies.get('active_redirect');

  if (isAuthenticated && activeRedirect === 'lookup-by-id') {
    return <Redirect push to="/v3/lookup-by-student-id" />;
  }

  return children;
};

export default PreDashboardRedirect;
